/* eslint-disable eqeqeq */
import React, {Fragment} from "react";
import {ContestListRequest, Contest} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {ContestsService} from "../../services/ContestsService";
import { ColumnType } from "../list/list/ColumnType";


interface State extends ListViewState<ContestListRequest> {
    form? : ContestListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class ContestsListView extends ListView<State, ContestListRequest> implements FormListener<ContestListRequest>{

    columns = [
        { property : "contestId", name : "ID", orderBy : "contestId"},
        { property : "contestName", name : "Name"},
        { property : "contestType", name : "Type"},
        { property : "createDate", name : "Created", type : ColumnType.DATE},
        { property : "url", name : "URL"}
    ];

    actions = [
       
    ];

    service : ContestsService;

    constructor(props : Props){
        super(props, "/contests/list");
        this.state = {...this.state,  listRequest : {...this.state.listRequest, orderBy : "contestId"}, validationMap : {}, form : {}};
        this.service = getContainer().getContestsService();
    }
    onSubmit() : void | Promise<any> {
        let form : ContestListRequest = Object.assign({},this.state.form);
        form.name = form.name ? form.name : undefined;
        form.id = form.id ?  form.id : undefined;
        if(form) {
            this.updateListState(form);
        }
    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: ContestListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : Contest, action : string) : Promise<any> | undefined {
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List Contests"
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <div className={"card-box"}>
                    <h4>Search Filters</h4>
                    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <FormGroup className={"form-group"}>
                            <label>Id</label>
                            <FormInput model={"id"} className={"form-control"} validators={[Validators.number()]}/>
                            <span className={"help-text"}>Search for contests by id</span>
                        </FormGroup>
                        <FormGroup className={"form-group"}>
                            <label>Name</label>
                            <FormInput model={"name"} className={"form-control"} validators={[Validators.strLength(1,255)]}/>
                            <span className={"help-text"}>Search for contests by name</span>
                        </FormGroup>
                        <Submit className={"btn btn-primary"}>Search</Submit>
                    </Form>
                </div>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(ContestsListView);
